import { render, staticRenderFns } from "./agv-shopping-bag.vue?vue&type=template&id=364ab4ca&scoped=true&lang=pug&"
import script from "./agv-shopping-bag.vue?vue&type=script&lang=js&"
export * from "./agv-shopping-bag.vue?vue&type=script&lang=js&"
import style0 from "./agv-shopping-bag.vue?vue&type=style&index=0&id=364ab4ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364ab4ca",
  null
  
)

export default component.exports